import { flag, integer, isoDay, list, oneOf, optionalText, record, text } from '../../../shared/decode'
import { ASSIGNMENT_KINDS, type Assignment, type Member, type Place, type ScheduleAccess } from '../model/types'

/** Декодеры ответов службы графика: форма проверяется на границе, а не при отрисовке (D-056). */

export function decodeAccess(raw: unknown): ScheduleAccess {
  const value = record(raw, 'access')
  return { canView: flag(value.canView, 'access.canView'), canManage: flag(value.canManage, 'access.canManage') }
}

function place(raw: unknown, field: string): Place {
  const value = record(raw, field)
  return {
    id: text(value.id, `${field}.id`),
    name: text(value.name, `${field}.name`),
    sortOrder: integer(value.sortOrder, `${field}.sortOrder`),
    archived: flag(value.archived, `${field}.archived`),
  }
}

export function decodePlace(raw: unknown): Place {
  return place(raw, 'place')
}

export function decodePlaces(raw: unknown): Place[] {
  const value = record(raw, 'places')
  return list(value.items, 'places.items', place)
}

function assignment(raw: unknown, field: string): Assignment {
  const value = record(raw, field)
  return {
    id: text(value.id, `${field}.id`),
    placeId: text(value.placeId, `${field}.placeId`),
    cashierId: text(value.cashierId, `${field}.cashierId`),
    date: isoDay(value.date, `${field}.date`),
    kind: oneOf(value.kind, ASSIGNMENT_KINDS, `${field}.kind`),
    updatedAt: optionalText(value.updatedAt, `${field}.updatedAt`) ?? '',
    updatedBy: optionalText(value.updatedBy, `${field}.updatedBy`) ?? '',
  }
}

export function decodeAssignments(raw: unknown): Assignment[] {
  const value = record(raw, 'assignments')
  return list(value.items, 'assignments.items', assignment)
}

function member(raw: unknown, field: string): Member {
  const value = record(raw, field)
  return { cashierId: text(value.cashierId, `${field}.cashierId`), addedAt: optionalText(value.addedAt, `${field}.addedAt`) ?? '' }
}

/** Состав объекта: кассиры, которые числятся на нём постоянно. */
export function decodeMembers(raw: unknown): Member[] {
  const value = record(raw, 'members')
  return list(value.items, 'members.items', member)
}
